import {
  CREATEBILL,
  CREATEBIRTHRECORD,
  CREATEDEATHRECORD,
  CREATEIPDBILL,
  CREATEIPDPRESCRIPTION,
  CREATEOPDBILL,
  CREATEOPDPRESCRIPTION,
  CREATEPATHOLOGY,
  CREATEPAYMENTRECEIPT,
  CREATEPAYSLIP,
  CREATEPHARMACYBILLL,
  CREATEPRINTAMBULANCE,
  CREATEPRINTBLOODBANK,
  CREATEPRINTDISCHARGE,
  CREATEPRINTOPERATION,
  CREATERADIOLOGY,
  DELETEBILL,
  DELETEBIRTHRECORD,
  DELETEDEATHRECORD,
  DELETEIPDBILL,
  DELETEIPDPRESCRIPTION,
  DELETEOPDBILL,
  DELETEOPDPRESCRIPTION,
  DELETEPATHOLOGY,
  DELETEPAYMENTRECEIPT,
  DELETEPAYSLIP,
  DELETEPHARMACYBILLL,
  DELETEPRINTAMBULANCE,
  DELETEPRINTBLOODBANK,
  DELETEPRINTDISCHARGE,
  DELETEPRINTOPERATION,
  DELETERADIOLOGY,
  GETBILL,
  GETBIRTHRECORD,
  GETDEATHRECORD,
  GETIPDBILL,
  GETIPDPRESCRIPTION,
  GETOPDBILL,
  GETOPDPRESCRIPTION,
  GETPATHOLOGY,
  GETPATHOLOGYCATEGORY,
  GETPAYMENTRECEIPT,
  GETPAYSLIP,
  GETPHARMACYBILLL,
  GETPRINTAMBULANCE,
  GETPRINTBLOODBANK,
  GETPRINTDISCHARGE,
  GETPRINTOPERATION,
  GETRADIOLOGY,
  UPDATEBILL,
  UPDATEBIRTHRECORD,
  UPDATEDEATHRECORD,
  UPDATEIPDBILL,
  UPDATEIPDPRESCRIPTION,
  UPDATEOPDBILL,
  UPDATEOPDPRESCRIPTION,
  UPDATEPATHOLOGY,
  UPDATEPAYMENTRECEIPT,
  UPDATEPAYSLIP,
  UPDATEPHARMACYBILLL,
  UPDATEPRINTAMBULANCE,
  UPDATEPRINTBLOODBANK,
  UPDATEPRINTDISCHARGE,
  UPDATEPRINTOPERATION,
  UPDATERADIOLOGY,
  CREATEQUOTATION,
  GETQUOTATION,
  DELETEQUOTATION,
  UPDATEQUOTATION,
  CREATEINVOICE,
  GETINVOICE,
  DELETEINVOICE,
  UPDATEINVOICE,
  CREATEOPDOUTDIETCHARTPRINT,
  GETOPDOUTDIETCHARTPRINT,
  UPDATEOPDOUTDIETCHARTPRINT,
  DELETEOPDOUTDIETCHARTPRINT,
  CREATEOPDOUTEXERCISEPRINT,
  GETOPDOUTEXERCISEPRINT,
  UPDATEOPDOUTEXERCISEPRINT,
  DELETEOPDOUTEXERCISEPRINT,
  CREATEOPDOUTDENTALCHARTPRINT,
  GETOPDOUTDENTALCHARTPRINT,
  UPDATEOPDOUTDENTALCHARTPRINT,
  DELETEOPDOUTDENTALCHARTPRINT,
  CREATEOPDOUTENDODONTICCHARTPRINT,
  GETOPDOUTENDODONTICCHARTPRINT,
  UPDATEOPDOUTENDODONTICCHARTPRINT,
  DELETEOPDOUTENDODONTICCHARTPRINT,
  CREATEOPDOUTLABWORKPRINT,
  GETOPDOUTLABWORKPRINT,
  UPDATEOPDOUTLABWORKPRINT,
  DELETEOPDOUTLABWORKPRINT

} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEINVOICE:
      return {
        ...state,
        invoiceSaveStatus: action.payload.success,
      };
    case GETINVOICE:
      return {
        ...state,
        invoiceList: action.payload.data,
      };
    case UPDATEINVOICE:
      return {
        ...state,
        invoiceUpdateStatus: action.payload.success,
      };
    case DELETEINVOICE:
      return {
        ...state,
        invoiceDeleteStatus: action.payload.success,
      };

    case CREATEQUOTATION:
      return {
        ...state,
        quotationSaveStatus: action.payload.success,
      };
    case GETQUOTATION:
      return {
        ...state,
        quotationList: action.payload.data,
      };
    case UPDATEQUOTATION:
      return {
        ...state,
        quotationUpdateStatus: action.payload.success,
      };
    case DELETEQUOTATION:
      return {
        ...state,
        quotationDeleteStatus: action.payload.success,
      };

    case CREATEOPDPRESCRIPTION:
      return {
        ...state,
        opdprescriptionSaveStatus: action.payload.success,
      };
    case GETOPDPRESCRIPTION:
      return {
        ...state,
        opdprescriptionList: action.payload.data,
      };
    case UPDATEOPDPRESCRIPTION:
      return {
        ...state,
        opdprescriptionUpdateStatus: action.payload.success,
      };

    case DELETEOPDPRESCRIPTION:
      return {
        ...state,
        opdprescriptionDeleteStatus: action.payload.success,
      };

    case CREATEOPDBILL:
      return {
        ...state,
        opdbillSaveStatus: action.payload.success,
      };
    case GETOPDBILL:
      return {
        ...state,
        opdbillList: action.payload.data,
      };
    case UPDATEOPDBILL:
      return {
        ...state,
        opdbillUpdateStatus: action.payload.success,
      };

    case DELETEOPDBILL:
      return {
        ...state,
        opdbillDeleteStatus: action.payload.success,
      };
    case CREATEIPDPRESCRIPTION:
      return {
        ...state,
        ipdprescriptionSaveStatus: action.payload.success,
      };
    case GETIPDPRESCRIPTION:
      return {
        ...state,
        ipdprescriptionList: action.payload.data,
      };
    case UPDATEIPDPRESCRIPTION:
      return {
        ...state,
        ipdprescriptionUpdateStatus: action.payload.success,
      };

    case DELETEIPDPRESCRIPTION:
      return {
        ...state,
        ipdprescriptionDeleteStatus: action.payload.success,
      };

    case CREATEIPDBILL:
      return {
        ...state,
        ipdbillSaveStatus: action.payload.success,
      };
    case GETIPDBILL:
      return {
        ...state,
        ipdbillList: action.payload.data,
      };
    case UPDATEIPDBILL:
      return {
        ...state,
        ipdbillUpdateStatus: action.payload.success,
      };

    case DELETEIPDBILL:
      return {
        ...state,
        ipdbillDeleteStatus: action.payload.success,
      };
    case CREATEBILL:
      return {
        ...state,
        billSaveStatus: action.payload.success,
      };
    case GETBILL:
      return {
        ...state,
        billList: action.payload.data,
      };
    case UPDATEBILL:
      return {
        ...state,
        billUpdateStatus: action.payload.success,
      };

    case DELETEBILL:
      return {
        ...state,
        billDeleteStatus: action.payload.success,
      };
    case CREATEPHARMACYBILLL:
      return {
        ...state,
        pharmacybillSaveStatus: action.payload.success,
      };
    case GETPHARMACYBILLL:
      return {
        ...state,
        pharmacybillprintList: action.payload.data,
      };
    case UPDATEPHARMACYBILLL:
      return {
        ...state,
        pharmacybillUpdateStatus: action.payload.success,
      };

    case DELETEPHARMACYBILLL:
      return {
        ...state,
        pharmacybillDeleteStatus: action.payload.success,
      };
    case CREATEPAYSLIP:
      return {
        ...state,
        payslipSaveStatus: action.payload.success,
      };
    case GETPAYSLIP:
      return {
        ...state,
        payslipList: action.payload.data,
      };
    case UPDATEPAYSLIP:
      return {
        ...state,
        payslipUpdateStatus: action.payload.success,
      };

    case DELETEPAYSLIP:
      return {
        ...state,
        payslipDeleteStatus: action.payload.success,
      };
    case CREATEPAYMENTRECEIPT:
      return {
        ...state,
        paymentreceiptSaveStatus: action.payload.success,
      };
    case GETPAYMENTRECEIPT:
      return {
        ...state,
        paymentreceiptList: action.payload.data,
      };
    case UPDATEPAYMENTRECEIPT:
      return {
        ...state,
        paymentreceiptUpdateStatus: action.payload.success,
      };

    case DELETEPAYMENTRECEIPT:
      return {
        ...state,
        paymentreceiptDeleteStatus: action.payload.success,
      };
    case CREATEBIRTHRECORD:
      return {
        ...state,
        birthrecordSaveStatus: action.payload.success,
      };
    case GETBIRTHRECORD:
      return {
        ...state,
        birthrecordList: action.payload.data,
      };
    case UPDATEBIRTHRECORD:
      return {
        ...state,
        birtrecordUpdateStatus: action.payload.success,
      };

    case DELETEBIRTHRECORD:
      return {
        ...state,
        birthrecordDeleteStatus: action.payload.success,
      };
    case CREATEDEATHRECORD:
      return {
        ...state,
        deathrecordSaveStatus: action.payload.success,
      };
    case GETDEATHRECORD:
      return {
        ...state,
        deathrecordList: action.payload.data,
      };
    case UPDATEDEATHRECORD:
      return {
        ...state,
        deathrecordUpdateStatus: action.payload.success,
      };

    case DELETEDEATHRECORD:
      return {
        ...state,
        deathrecordDeleteStatus: action.payload.success,
      };
    case CREATEPATHOLOGY:
      return {
        ...state,
        pathologySaveStatus: action.payload.success,
      };
    case GETPATHOLOGY:
      return {
        ...state,
        pathologyList: action.payload.data,
      };
    case UPDATEPATHOLOGY:
      return {
        ...state,
        pathologyUpdateStatus: action.payload.success,
      };

    case DELETEPATHOLOGY:
      return {
        ...state,
        pathologyDeleteStatus: action.payload.success,
      };
    case CREATERADIOLOGY:
      return {
        ...state,
        radiologySaveStatus: action.payload.success,
      };
    case GETRADIOLOGY:
      return {
        ...state,
        radiologyList: action.payload.data,
      };
    case UPDATERADIOLOGY:
      return {
        ...state,
        radiologyUpdateStatus: action.payload.success,
      };

    case DELETERADIOLOGY:
      return {
        ...state,
        radiologyDeleteStatus: action.payload.success,
      };
    case CREATEPRINTOPERATION:
      return {
        ...state,
        operationSaveStatus: action.payload.success,
      };
    case GETPRINTOPERATION:
      return {
        ...state,
        operationPrintList: action.payload.data,
      };
    case UPDATEPRINTOPERATION:
      return {
        ...state,
        operationUpdateStatus: action.payload.success,
      };

    case DELETEPRINTOPERATION:
      return {
        ...state,
        operationDeleteStatus: action.payload.success,
      };
    case CREATEPRINTBLOODBANK:
      return {
        ...state,
        bloodbankSaveStatus: action.payload.success,
      };
    case GETPRINTBLOODBANK:
      return {
        ...state,
        bloodbankList: action.payload.data,
      };
    case UPDATEPRINTBLOODBANK:
      return {
        ...state,
        bloodbankUpdateStatus: action.payload.success,
      };

    case DELETEPRINTBLOODBANK:
      return {
        ...state,
        bloodbankDeleteStatus: action.payload.success,
      };
    case CREATEPRINTAMBULANCE:
      return {
        ...state,
        ambulanceSaveStatus: action.payload.success,
      };
    case GETPRINTAMBULANCE:
      return {
        ...state,
        ambulancePrintList: action.payload.data,
      };
    case UPDATEPRINTAMBULANCE:
      return {
        ...state,
        ambulanceUpdateStatus: action.payload.success,
      };

    case DELETEPRINTAMBULANCE:
      return {
        ...state,
        ambulanceDeleteStatus: action.payload.success,
      };
    case CREATEPRINTDISCHARGE:
      return {
        ...state,
        dischargeSaveStatus: action.payload.success,
      };
    case GETPRINTDISCHARGE:
      return {
        ...state,
        dischargeList: action.payload.data,
      };
    case UPDATEPRINTDISCHARGE:
      return {
        ...state,
        dischargeUpdateStatus: action.payload.success,
      };

    case DELETEPRINTDISCHARGE:
      return {
        ...state,
        dischargeDeleteStatus: action.payload.success,
      };

    case CREATEOPDOUTDIETCHARTPRINT:
      return {
        ...state,
        opddietchartSaveStatus: action.payload.success,
      };
    case GETOPDOUTDIETCHARTPRINT:
      return {
        ...state,
        opddietchartList: action.payload.data,
      };
    case UPDATEOPDOUTDIETCHARTPRINT:
      return {
        ...state,
        opddietchartUpdateStatus: action.payload.success,
      };

    case DELETEOPDOUTDIETCHARTPRINT:
      return {
        ...state,
        opddietchartDeleteStatus: action.payload.success,
      };

    case CREATEOPDOUTEXERCISEPRINT:
      return {
        ...state,
        opdexerciseSaveStatus: action.payload.success,
      };
    case GETOPDOUTEXERCISEPRINT:
      return {
        ...state,
        opdexerciseList: action.payload.data,
      };
    case UPDATEOPDOUTEXERCISEPRINT:
      return {
        ...state,
        opdexerciseUpdateStatus: action.payload.success,
      };

    case DELETEOPDOUTEXERCISEPRINT:
      return {
        ...state,
        opdexerciseDeleteStatus: action.payload.success,
      };
      case CREATEOPDOUTDENTALCHARTPRINT:
        return {
          ...state,
          opddentalprintSaveStatus: action.payload.success,
        };
      case GETOPDOUTDENTALCHARTPRINT:
        return {
          ...state,
          opddentalprintList: action.payload.data,
        };
      case UPDATEOPDOUTDENTALCHARTPRINT:
        return {
          ...state,
          opddentalprintUpdateStatus: action.payload.success,
        };
  
      case DELETEOPDOUTDENTALCHARTPRINT:
        return {
          ...state,
          opddentalprintDeleteStatus: action.payload.success,
        };
        
        case CREATEOPDOUTENDODONTICCHARTPRINT:
          return {
            ...state,
            opdendodonticprintSaveStatus: action.payload.success,
          };
        case GETOPDOUTENDODONTICCHARTPRINT:
          return {
            ...state,
            opdendodonticprintList: action.payload.data,
          };
        case UPDATEOPDOUTENDODONTICCHARTPRINT:
          return {
            ...state,
            opdendodonticprintUpdateStatus: action.payload.success,
          };
    
        case DELETEOPDOUTENDODONTICCHARTPRINT:
          return {
            ...state,
            opdendodonticprintDeleteStatus: action.payload.success,
          };
  
          case CREATEOPDOUTLABWORKPRINT:
            return {
              ...state,
              opdLabWorkcprintSaveStatus: action.payload.success,
            };
          case GETOPDOUTLABWORKPRINT:
            return {
              ...state,
              opdLabWorkcprintList: action.payload.data,
            };
          case UPDATEOPDOUTLABWORKPRINT:
            return {
              ...state,
              opdLabWorkcprintUpdateStatus: action.payload.success,
            };
      
          case DELETEOPDOUTLABWORKPRINT:
            return {
              ...state,
              opdLabWorkcprintDeleteStatus: action.payload.success,
            };


    default:
      return state;
  }
}
